var map = {
	"./account.svg": "P8cv",
	"./add-s.svg": "YDUK",
	"./address.svg": "Oz7W",
	"./alchemy-logo-dark.png": "f2LY",
	"./arrow.svg": "l4LJ",
	"./avatar1.png": "GTyY",
	"./avatar2.png": "ciMv",
	"./babe.svg": "zMHy",
	"./back.svg": "wYpQ",
	"./bb1.png": "RRck",
	"./bb2.png": "XC96",
	"./bb3.png": "w8Bi",
	"./bb4.png": "4YgO",
	"./bb5.png": "IHXC",
	"./bb6.png": "NQF7",
	"./bg2.png": "CjTQ",
	"./bg3.png": "VTmb",
	"./bitkeep.png": "KLiv",
	"./camera.svg": "oxpW",
	"./close.svg": "zaOT",
	"./company.svg": "UPhn",
	"./copy.svg": "+RRG",
	"./delete.svg": "MgmV",
	"./discod.svg": "egF0",
	"./down.svg": "EHx1",
	"./down1.svg": "mq8z",
	"./down2.svg": "aD5C",
	"./edit.svg": "RgRl",
	"./email.svg": "yko3",
	"./empty.png": "Bm30",
	"./error.svg": "YVd6",
	"./facebook.svg": "8l/X",
	"./facebook1.svg": "neVr",
	"./facebook2.svg": "80hZ",
	"./fan.svg": "XXTy",
	"./game-bg.svg": "F/Aq",
	"./game-bg2.svg": "LBbA",
	"./guide-bg.png": "pAae",
	"./guide-bg2.png": "+nKr",
	"./guide1.png": "6Gti",
	"./guide2.png": "LEH4",
	"./guide3.png": "pgy5",
	"./home.png": "KSZv",
	"./ico1.png": "yP2F",
	"./ico11.png": "9QUO",
	"./ico22.png": "JHZN",
	"./ico3.png": "Fjcd",
	"./ico33.png": "L9/M",
	"./icon1.png": "d0yY",
	"./icon1.svg": "jNbj",
	"./icon11.png": "gImq",
	"./icon2.png": "ceFa",
	"./icon2.svg": "Tz3m",
	"./icon22.png": "LKEn",
	"./icon3.png": "akCb",
	"./icon33.png": "U0px",
	"./icon4.png": "72gb",
	"./icon44.png": "WPlM",
	"./imtoken.png": "fiJE",
	"./info.png": "9/up",
	"./info.svg": "kEE0",
	"./jackpot.svg": "nPDL",
	"./lang.svg": "xw7M",
	"./lin.svg": "HXAc",
	"./logo.svg": "zxL1",
	"./logout.svg": "s5be",
	"./marquee.png": "tgd+",
	"./mcn.svg": "DeDU",
	"./menu.svg": "Ehsk",
	"./metamask.png": "9xKK",
	"./mi.png": "G/AX",
	"./nfts.png": "GEPX",
	"./no-act.png": "xmt2",
	"./no.svg": "Upc4",
	"./onramper.svg": "d0JU",
	"./over.png": "cuPE",
	"./oversuccess.png": "aapY",
	"./pa.svg": "27/C",
	"./photo.svg": "KbB/",
	"./photo1.svg": "5Q6j",
	"./play.svg": "MHYQ",
	"./question.svg": "s2NW",
	"./right.png": "SuS5",
	"./select.svg": "684M",
	"./select2.svg": "oGn+",
	"./selected.png": "F3gO",
	"./service.svg": "dW+t",
	"./share.svg": "N9Vd",
	"./share1.svg": "g9mK",
	"./shopify.png": "5EbP",
	"./success.svg": "auP6",
	"./success2.svg": "KNTy",
	"./telegram.svg": "kW/x",
	"./ticket.svg": "7eX1",
	"./tip-bg.svg": "mjZw",
	"./tit.svg": "tq8B",
	"./tit1.svg": "OFbH",
	"./twitter.svg": "ODvK",
	"./twitter1.svg": "ISlr",
	"./union.svg": "rXJ7",
	"./up.svg": "wd2o",
	"./up1.svg": "lx3g",
	"./warning.svg": "Z6RD",
	"./welcome.png": "6ozE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 2